import React from 'react'

const Loader = () => {
  return (
    <span className="loader" id="loader-1" title="Loading Page..."></span>
  )
}

export default Loader